import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Shared by RegionHealthPanel (Fix-It banner) and RegionSettingsPanel (inline
// suggestion when Auto-assign is switched ON) — one click adds the region to
// a Manager's regions, then sets them as its owner.
export const assignRegionOwner = async (candidate, region) => {
  await axios.put(
    `${BACKEND_URL}/api/admin/team-accounts/${candidate.username}`,
    { regions: [...candidate.regions, region] },
    { withCredentials: true }
  );
  await axios.put(
    `${BACKEND_URL}/api/admin/team-accounts/${candidate.username}/region-owner`,
    { region, is_owner: true },
    { withCredentials: true }
  );
};
